import React from "react";
import { AppProvider } from "@context/AppContext";

import "./src/styles/global.css";
import "./src/styles/cookies.css";
import "./src/styles/fonts.css";

export const wrapRootElement = ({ element }) => (
  <AppProvider>{element}</AppProvider>
);

// Handle hash redirect #efficacy -> #resilient-trial
export const onRouteUpdate = ({ location }) => {
  if ( location.pathname === "/efficacy" && location.hash === "#efficacy") {
    window.location.replace(
      `${location.pathname}#resilient-trial`
    );
  }
};

// Track previous pathname to detect new page navigations
let previousPathname = null;

export const shouldUpdateScroll = ({
  routerProps: { location },
}) => {
  const currentPathname = location.pathname;
  const isNewPage = previousPathname !== currentPathname;

  if (location.hash) {
    const targetId = location.hash.substring(1);

    // First, scroll to the top of the page only if navigating to a new page
    if (isNewPage) {
      window.scrollTo(0, 0);
    }

    // Then, scroll to the hash target after a brief delay
    setTimeout(() => {
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        // First, open the accordion and wait for layout changes
        window.dispatchEvent(new CustomEvent("open-accordion", { detail: { targetId: targetId } }));
        
        // Then scroll after accordion animation completes
        setTimeout(() => {
          targetElement.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }, 300);
      }
    }, 200);
    
    // Update previous pathname for next navigation
    previousPathname = currentPathname;
    return false;
  }

  // Update previous pathname for next navigation
  previousPathname = currentPathname;
  
  // For regular page navigation (no hash), scroll to top
  return true;
};
